import type { ConstructionTypeType } from '@/types/ui/inspection/constructionTypeTypes'
import {
  roofTile,
  windowFrame,
  exteriorWetMaterial,
  exteriorDryMaterial,
  exteriorWetMaterialRC,
  exteriorDryMaterialRC,
  signboard,
  outdoorStairs,
  otherItem,
  roofMaterial
} from './fallingCards'
import { CONSTRUCTION_TYPE } from '@/constants/accessor/api/emergencyInspectionResult/assessmentInfo/constructionType'

const WOOD = [
  roofTile,
  windowFrame,
  exteriorWetMaterial,
  exteriorDryMaterial,
  signboard,
  outdoorStairs,
  otherItem
]

const STEEL = [
  roofMaterial,
  windowFrame,
  exteriorWetMaterial,
  exteriorDryMaterial,
  signboard,
  outdoorStairs,
  otherItem
]

const RC = [
  windowFrame,
  exteriorWetMaterialRC,
  exteriorDryMaterialRC,
  signboard,
  outdoorStairs,
  otherItem
]

const card = {
  [CONSTRUCTION_TYPE.WOOD]: WOOD,
  [CONSTRUCTION_TYPE.STEEL]: STEEL,
  [CONSTRUCTION_TYPE.RC]: RC
}

/**
 * 指定された建物構造タイプに対応するカードオブジェクトを返却する
 *
 * @param selectedConstructionType 選択された構造タイプ
 * @returns 該当するカードオブジェクト
 */
export const getFallingCards = (selectedConstructionType: ConstructionTypeType) => {
  const cards = card[selectedConstructionType]

  if (!cards) {
    console.error(`Invalid construction type: ${selectedConstructionType}`)
    return null
  }

  return cards
}
